import { defineStore } from 'pinia'
import { asyncRouterMap, constantRouterMap } from '@/router/routes'

function hasPermission(menus, route) {
  if (route.name) {
    const currMenu = getMenu(route.name, menus)
    if (currMenu != null) {
      if (!route.meta) route.meta = {}
      if (currMenu.title != null && currMenu.title !== '') route.meta.title = currMenu.title
      if (currMenu.icon != null && currMenu.title !== '') route.meta.icon = currMenu.icon
      if (currMenu.hidden != null && route.hidden !== true) route.hidden = currMenu.hidden !== 0
      if (currMenu.sort != null && currMenu.sort !== '') route.sort = currMenu.sort
      return true
    } else {
      route.sort = 0
      if (route.hidden !== undefined && route.hidden === true) {
        route.sort = -1
        return true
      }
      return false
    }
  }
  return true
}

function getMenu(name, menus) {
  for (let i = 0; i < menus.length; i++) {
    if (name === menus[i].name) return menus[i]
  }
  return null
}

function compare(p) {
  return (m, n) => n[p] - m[p]
}

function sortRouters(accessedRouters) {
  for (const router of accessedRouters) {
    if (router.children && router.children.length > 0) {
      router.children.sort(compare('sort'))
    }
  }
  accessedRouters.sort(compare('sort'))
}

export const usePermissionStore = defineStore('permission', {
  state: () => ({
    routers: constantRouterMap,
    addRouters: []
  }),

  actions: {
    GenerateRoutes(data) {
      const { menus } = data
      const accessedRouters = asyncRouterMap.filter(v => {
        if (hasPermission(menus, v)) {
          if (v.children && v.children.length > 0) {
            v.children = v.children.filter(child => hasPermission(menus, child))
          }
          return true
        }
        return false
      })
      sortRouters(accessedRouters)
      this.addRouters = accessedRouters
      this.routers = constantRouterMap.concat(accessedRouters)
    }
  }
})
